import SkeletonImage from "./SkeletonImage";
import SkeletonInput from "./SkeletonInput";

const Image = SkeletonImage;
const Input = SkeletonInput;

export default { Image, Input };
